module.exports = __webpack_public_path__ + "static/media/peopleGreen.19fcf3cb.svg";